import {
  SET_DATA,
  SET_VALUE,
  SET_ARRAY,
  CLEAR_DATA
} from './mutation-types'

const axios = require('axios')
const f = require('../lib/functions')

export default {
  setValue(context, request) {
    context.commit(SET_VALUE, request)
  },
  setData(context, request) {
    context.commit(SET_DATA, request)
  },
  setArray(context, request) {
    context.commit(SET_ARRAY, request)
  },
  clearData(context, request){
    context.commit(CLEAR_DATA, request)
  },
  fetchData(context, request) {
    return new Promise((resolve, reject) => {
      axios.get(request.url)
      .then((response) => {
        request.data = {}
        _.forEach(response.data, (item) => {
          switch(request.mode){
            case 'masters':
              request.data[item.id] = item
              break
            case 'constants':
              request.data[item.attributes.id] = item.attributes
              break
          }
        })
        context.commit(SET_DATA, request)
        resolve()
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
}
